import { useSelector } from 'react-redux';
import { componentMap } from './ChannelContent.js';
import ContactListView from './call/ContactListView';

// Component that renders the content of a specific channel (used for animation snapshots)
export default function ChannelSnapshot({ channelKey, frozenState }) {
  const currentChannelConfig = useSelector((state) => state.channel.channelConfig);
  const channelConfig = frozenState?.channelConfig || currentChannelConfig;

  if (!channelKey || !channelConfig[channelKey]) {
    return null;
  }

  // Render the appropriate component based on channel type
  const renderChannelContent = () => {
    const channelType = channelConfig[channelKey]?.type;
    // Never render VoiceCallView in snapshots — it would create a duplicate LiveKit connection.
    // Render ContactListView instead (safe, no connections) so the close animation matches other channels.
    if (channelType === 'call') {
      return <ContactListView />;
    }
    const Component = componentMap[channelKey];
    if (Component) return <Component />;
    return (
      <div className="flex items-center justify-center h-full bg-gray-100">
        <div className="text-center">
          <div className="text-4xl mb-2">📱</div>
          <div className="text-lg font-semibold text-gray-700 capitalize">
            {channelConfig[channelKey]?.title || channelKey}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full overflow-hidden">
      {renderChannelContent()}
    </div>
  );
}
